<template>
    <div class="flex flex-col h-screen">
        <div class="flex-1 p-4 overflow-y-auto">
            <div class="text-gray text-sm mb-4">Карточка сотрудника</div>
            <div class="flex mb-5" v-if="employment">
                <Avatar :url="avatar" :first-name="employment.user.first_name" :last-name="employment.user.last_name" size="md" v-if="employment" />
                <div class="ml-4">
                    <div class="text-sm semibold text-darkgray">{{ fullName }}</div>
                    <div class="text-xs text-gray" v-if="position">{{ position.name }}</div>
                    <div class="text-xs text-gray">{{ department?.name }}</div>
                </div>
            </div>

            <EmployeeStats class="mb-3"  :schedule />

            <EmployeeData :employment="employment" :user="employment.user" class="mb-5"
                v-if="employment" @cancel="emit('cancel')" />

            <EmployeeTabs :employment v-if="employment" @cancel="emit('cancel')" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Avatar from '../Avatar.vue'
import EmployeeStats from './EmployeeStats.vue'
import dayjs from "dayjs"
import { Schedule } from '@/types'
import EmployeeData from './EmployeeData.vue'
import EmployeeTabs from './EmployeeTabs.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'

interface Props {
    schedule: Schedule,
    employment: any
}

dayjs.locale('ru')

const emit = defineEmits(['cancel'])

const store = useScheduleStore()
const departmentStore = useDepartmentStore()

const { schedule, employment } = defineProps<Props>()

const fullName = computed(() => {
    const ln:string = (employment?.user.last_name) ? employment?.user.last_name : ''
    const fn:string = (employment?.user.first_name) ? employment?.user.first_name : ''
    const mn:string = (employment?.user?.middle_name) ? employment?.user?.middle_name : ''
    return `${ln} ${fn} ${mn}`
})
const position = computed(() => store.positions.find(item => item.id === employment?.position))
const department = computed(() => departmentStore.departments.find(item => item.id === employment?.department))
const avatar = computed(() => employment?.user.avatar)

</script>
